/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'fabric.reactions.add': 'Lägg till reaktion',
  'fabric.reactions.error.unexpected': 'Reaktioner är inte tillgängliga just nu',
  'fabric.reactions.loading': 'Läser in ...',
  'fabric.reactions.more.emojis': 'Fler emojis',
  'fabric.reactions.other.reacted.users': '{count, plural, one {och en annan} other {och {count} andra}}',
  'fabric.reactions.reactwithemoji': 'Reagera med emojin {emoji}',
  'fabric.reactions.summary': 'Visa alla reaktioner från användare',
  'reaction-picker-trigger.add.reaction.message': 'Lägg till en reaktion',
  'reactions.dialog.close': 'Stäng',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Vänster navigering',
  'reactions.dialog.reactions.count':
    '{count, plural, one {{count,number} reaktion} other {{count,number} reaktioner}}',
  'reactions.dialog.right.navigate': 'Höger navigering',
  'reactions.dialog.viewall': 'Visa alla',
  'reactions.dialog.viewall.tooltip': 'Visa alla reaktioner från användare',
};
